export default __webpack_public_path__ + "static/media/neuralnet.01f95386.png";